import React from 'react';
import { ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Tooltip } from 'fw/components'

class Label extends React.Component {
	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.required !== this.props.required
			|| nextProps.children !== this.props.children);
	}

	render() {
		return (
			<ControlLabel {...this.props}>
				{this.props.children} {this.props.required && <span className="required-indicator">*</span>}
				{this.props.tip && <Tooltip tip={this.props.tip} />}
			</ControlLabel>
		)
	}
}

Label.propTypes = {
	required: PropTypes.bool
}

export default Label;


// WEBPACK FOOTER //
// ./src/fw/components/label/Label.js